import React, { Component } from 'react'
import Bolts from './Bolts.png'
import * as SimpleWebAuthnBrowser from '@simplewebauthn/browser'
import Crypto from './Crypto'
import './LoginDialog.css'

class LoginDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      InProgress: true,
    }
    this.Request()
  }
  async Request() {
	try {
		console.log('Crypto.PublicKey', Crypto.PublicKey)
		this.setState({InProgress: true, Error: false})
		const Response = await fetch('/Passkey/Auth/Start', {  
			method: 'POST', headers: {'Content-Type': 'application/json'},  
			body: JSON.stringify({DeviceKey: Crypto.PublicKey})  
		}).then(async r=>{return {...await r.json(), Key: r.headers.get('Session-Key')}}).catch(e=>{return {Error:e.message}})
		if (Response?.Error||!Response) {
			return this.setState({InProgress: false, Error: Response?.Error||"Error requesting passkey session"})
		}
		const assertionResponse = await SimpleWebAuthnBrowser.startAuthentication({optionsJSON: Response.publicKey}).catch(e=>{return{Error:"Error validating key" + e.message}})  
		if (assertionResponse.Error) {
		return this.setState({InProgress: false, Error: assertionResponse.Error||"Assertion Error"})
		}
		const verificationResponse = await fetch('/Passkey/Auth/Finish', {  
			method: 'POST',  
			headers: {  
				'Content-Type': 'application/json',
				'Session-Key': Response.Key,
			},  
			body: JSON.stringify(assertionResponse)  
		})
		const Response2 = await verificationResponse.json()
		if (Response2?.Token) {
			localStorage.setItem('Token', Response2.Token)
			this.props.onLogin()
		} else if (Response2.Error) {
			return this.setState({InProgress: false, Error: Response2.Error||"Login Error"})
		}
	} catch (e) {
	}
	this.setState({InProgress: false})
}
  render() {
    return (
    <div className="LoginDialog">
      <div className="Center"><img src={Bolts} /></div>
        {(this.state.Error || !this.state.InProgress)?(
          <>
            <p>There was an issue using your passkey to log you in.</p>
            <p class="Error">{this.state.Error}</p>
            <button className="Large" style={{display:this.state.InProgress?'none':'block'}} onClick={()=>this.Request()}>Retry</button>
            </>
        ):(
          <h3 className="Center">Log in using your passkey</h3>
        )}
    </div>
    )
  }
}

export default LoginDialog
